import React from 'react';
import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CardContainer.css';

const CardContainer = ({ items, isContactLayout = false }) => {
    return (
        <div className='cardContainer__container'>
            {items.map(item => (
                <Card key={item.id} className={`cardContainer__card ${isContactLayout ? 'cardContainer__contactLayout' : ''}`}>
                    {isContactLayout ? (
                        <div className="cardContainer__contactLayout-content">
                            <div className="cardContainer__contactLayout-icon-container">
                                <FontAwesomeIcon icon={item.icon} size="3x" />
                            </div>
                            <Card.Body className="cardContainer__contactLayout">
                                <Card.Title className="cardContainer__title">{item.title}</Card.Title>
                                {typeof item.description === 'string' ? (
                                    <Card.Text className="cardContainer__text">{item.description}</Card.Text>
                                ) : (
                                    <Card.Text className="cardContainer__text">{item.description}</Card.Text>
                                )}
                            </Card.Body>
                        </div>
                    ) : (
                        <>
                            <div className="cardContainer__icon-container">
                                <FontAwesomeIcon icon={item.icon} size="4x" />
                            </div>
                            <Card.Body>
                                <Card.Title className="cardContainer__title">{item.title}</Card.Title>
                                {typeof item.description === 'string' ? (
                                    <Card.Text className="cardContainer__text">{item.description}</Card.Text>
                                ) : (
                                    <Card.Text className="cardContainer__text">{item.description}</Card.Text>
                                )}
                            </Card.Body>
                        </>
                    )}
                </Card>
            ))}
        </div>
    );
};

export default CardContainer;
